module.exports = __webpack_public_path__ + "img/edcb716.png";